export default "__VITE_ASSET__BLmbY4b1__"